import React, { ReactNode } from 'react'

export const CountCardContainer: React.FC<{
  children: ReactNode
  className?: string
}> = ({ children, className }) => {
  return (
    <div
      className={`
            grid max-md:grid-cols-1 md:grid-flow-row 
            md:grid-cols-[repeat(auto-fit,_minmax(300px,300px))]
            gap-5 my-10
            ${className}
            `}
    >
      {children}
    </div>
  )
}
